import { Timestamp } from "firebase/firestore";
import { SearchHelper } from "../../utils/helpers";

export const roleToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    const tenantName = typeof tenantData === 'string' ? '' : (tenantData?.tenantName || tenantData?.name || '');
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const cleanName = data.name?.trim() || "Novo Cargo";

    const payload = {
        idTenant,
        tenantName,
        name: cleanName,
        searchName: SearchHelper.normalize(cleanName),
        description: data.description?.trim() || "",
        status: data.status,

        // MAPA DE PERMISSÕES BOLEANAS
        permissions: data.permissions || {},

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: (data.id && data.createdBy) ? data.createdBy : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    // Garante que o objeto não envie "undefined" acidentalmente no update do modelo.
    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

    return payload;
};

/**
 * Mapeia os dados do Firestore para o React.
 */
export const roleFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        permissions: data.permissions || {},
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
